import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ALL_PAYMENTS_MODES } from "../../../helper/reportsHelper";


type PaymentsModeFilterProps = {
  value?: string[];
  onChange: (value: string[]) => void;
};

const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;
export const PaymentsModeFilter: React.FC<PaymentsModeFilterProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();


  const paymentsModeOptions = ALL_PAYMENTS_MODES.map(
    (payment) => ({
      value: payment.code,
      label: payment.name,
    })
  );
  return (
    <SelectBoxWrapper>
      <Select
        mode="multiple"
        allowClear
        placeholder={t("payments.table.column.payment_mode")}
        style={{ width: "100%", minWidth: 150 }}
        maxTagCount={1}
        options={paymentsModeOptions}
        onChange={onChange}
        value={value}
      />
    </SelectBoxWrapper>
  );
};